<template>
  <div class="media">
        <div class="img-container">
            <div class="content">
                <img :src="news.Image.Url">
            </div>
        </div>
        <div class="media-body">
            <router-link class="title" :to="{ name: 'view-news', params: { id: news.Id } }">{{ news.Title }}</router-link>
            <p>{{ news.Subdescription }}</p>
            <router-link class="co-orange" :to="{ name: 'view-news', params: { id: news.Id } }">قراءة المزيد »</router-link>
        </div>
  </div>
</template>
<script>
export default {
    props: {
        news: {
            type: Object,
            default: () => ({
                Title: null,
                Subdescription: null,
                Description: null,
                Image: {
                    Url: null
                },
            })
        }
    }
}
</script>
<style lang="scss">
  @import "src/assets/sass/app.scss";

    .media{
        width:100%;
        padding:5px 0px;
        margin-bottom:10px;
        @include transition-duration(0.5s);
            .img-container{
                margin-left: 10px;
                border:1px solid #ccc;
                border-radius:10px;
                width:27%;
                @include margin-right(15px,$dir);
                @include float-left($dir);
                @include aspect-ratio(4,3);
                @media(max-width:480px){
                    width:100%;
                    margin-bottom:10px;
                }
                img{
                    width:100%;
                    height: 100%;
                    border-radius: 5px;
                    object-fit: cover;
                }
            }
            .media-body{
                @include margin-left(10px, $dir);
                direction:$dir;
                @media(max-width:480px)
                    {
                        @include padding-left(10px ,$dir);
                    }
                .title{
                    h3{
                        @include multiline-ellipses(21px,1.2,1);
                        direction:$dir;
                    }
                    color:#222;
                    font-weight: bold;
                    @include text-align($dir);
                    &:hover , &:focus{
                        color:$main-color;
                        text-decoration: none;
                    }
                }
                p{
                    direction:$dir;
                    @include text-align($dir);
                    @include multiline-ellipses(15px,1.2,3);
                    color:$p-color;
                    @include padding-right(15px);
                    margin:3px 0px;
                }
            }
    }
</style>



// WEBPACK FOOTER //
// src/components/news and events/new.vue